/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-07-21 09:19:00
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-07-21 09:43:32
 */
import React, { Fragment } from 'react'
import CustomModal from "../../../../components/CustomModal"
import closeimg from '../img/icon-close.png'
import { transformtime } from '../../../../../utils/tools'
import { getProductInspectionOrderDetails } from './actions'
import { Button, message, Modal } from 'antd';
import axios from 'axios';
import { connect } from 'react-redux'
import FileViewer from 'react-file-viewer'
import PDFViewer from 'react-pdf-js'
class OrderDetail extends React.Component {
    state = {
        orderDetail: {},
        orderType: 1,
        productInspectionOrderDownload: null,

        filePreviewPath: '',//文档预览路径
        nowClickFile: undefined,//当前点击的文件
        preLookModalFlag: false,
        pdfPage: 1,//PDF预览时当前页面数
        pdfTotalPages: 0,//PDF总页数
    }

    componentDidMount() {
        if (this.props.OrderDetailOnRefComponent) this.props.OrderDetailOnRefComponent(this);
    }


    show = async (orderDetail, type) => {
        console.log(orderDetail, type)
        this.main.show()
        // console.log(orderDetail)
        if (type != 6) {
            this.setState({
                orderDetail: orderDetail,
                orderType: type
            })
        } else {
            let res
            // res = await getProductInspectionOrderDetails(orderDetail.orderCode)
            res = await getProductInspectionOrderDetails(orderDetail.orderCode)
            console.log("show", res);
            if (!res) {
                this.setState({
                    orderDetail: {},
                    orderType: type,
                    productInspectionOrderDownload: null
                })
            } else {
                // console.log(res)
                if (!res.data.validationReport) {
                    this.setState({
                        orderDetail: res.data.orderInfo,
                        orderType: type,
                        productInspectionOrderDownload: null
                    })
                    return;
                }
                this.setState({
                    orderDetail: res.data.orderInfo,
                    orderType: type,
                    productInspectionOrderDownload: res.data.validationReport.validationReportDownload
                })
            }
        }

    }

    getproductInspectionOrderDownload = () => {
        if (navigator.clipboard && window.isSecureContext) {
            // navigator clipboard 向剪贴板写文本
            message.success('订单下载url已复制')
            navigator.clipboard.writeText(this.state.productInspectionOrderDownload)
        } else {
            // 创建text area
            const textArea = document.createElement('textarea')
            textArea.value = this.state.productInspectionOrderDownload
            // 使text area不在viewport，同时设置不可见
            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()
            message.success('订单下载url已复制')
            document.execCommand('copy')
            textArea.remove()
        }
    }

    downLoadFlie = (url) => {
        if (navigator.clipboard && window.isSecureContext) {
            // navigator clipboard 向剪贴板写文本
            message.success('订单下载url已复制')
            navigator.clipboard.writeText(url)
        } else {
            // 创建text area
            const textArea = document.createElement('textarea')
            textArea.value = url
            // 使text area不在viewport，同时设置不可见
            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()
            message.success('订单下载url已复制')
            document.execCommand('copy')
            textArea.remove()
        }
    }

    render() {

        const { orderDetail, orderType, productInspectionOrderDownload,
            nowClickFile, preLookModalFlag, pdfPage, pdfTotalPages, filePreviewPath } = this.state

        return (
            <CustomModal ref={ref => this.main = ref}>
                <div className='order-detail-modal'>
                    <div className={'order-detail-modal-title modal-dragable'} >
                        {'订单详情'}
                        <img src={closeimg} alt="关闭" className={'order-detail-modal-closeimg'} onClick={() => this.main.close()}></img>
                    </div>
                    <div className='order-detail-divider'></div>

                    {orderType === 0 ?
                        <div className="order-detail-content-wrap">
                            <div className="order-detail-name-wrap">
                                <div className="order-detail-name">订单编号：</div>
                                <div className="order-detail-name-content" title={orderDetail.orderId}>{orderDetail.orderId}</div>
                            </div>
                            <div className="order-detail-name-wrap">
                                <div className="order-detail-name">创建时间：</div>
                                <div className="order-detail-name-content">{transformtime(orderDetail.orderCreationTime, 'yyyy-mm-dd hh:mm:ss')}</div>
                            </div>
                            <div className="order-detail-name-wrap">
                                <div className="order-detail-name">数据来源：</div>
                                <div className="order-detail-name-content">{orderDetail.resourceType ? orderDetail.resourceType : "暂无"}</div>
                                {/* <div className="order-detail-name-content">{"生产定制"}</div> */}
                            </div>
                            <div className="order-detail-name-wrap">
                                <div className="order-detail-name">子订单数：</div>
                                <div className="order-detail-name-content">{orderDetail.downLoadOrderFilesList ? orderDetail.downLoadOrderFilesList.length : "暂无"}</div>
                            </div>
                            <div className="order-detail-name-wrap">
                                <div className="order-detail-name">处理状态：</div>
                                <div className="order-detail-name-content">{orderDetail.orderStatus ? orderDetail.orderStatus : "暂无"}</div>
                            </div>
                        </div> :
                        orderType === 1 ?
                            <div className="order-detail-content-wrap">
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">子订单号：</div>
                                    <div className="order-detail-name-content" title={orderDetail.id}>{orderDetail.id}</div>
                                </div>
                                {orderType !== 1 && <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">创建时间：</div>
                                    <div className="order-detail-name-content">{transformtime(orderDetail.orderCreationTime, 'yyyy-mm-dd hh:mm:ss')}</div>
                                </div>}
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">文件名称：</div>
                                    <div className="order-detail-name-content" title={orderDetail.fileName}>{orderDetail.fileName ? orderDetail.fileName : "暂无"}</div>
                                </div>
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">文件大小：</div>
                                    <div className="order-detail-name-content">{orderDetail.fileSize ? this.returnFileSizeText(orderDetail.fileSize) : "暂无"}</div>
                                </div>
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">数据来源：</div>
                                    <div className="order-detail-name-content">{orderDetail.resourceType ? orderDetail.resourceType : "暂无"}</div>
                                </div>
                                {/* <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">花费积分：</div>
                                    <div className="order-detail-name-content">{orderDetail.score ? orderDetail.score : "暂无"}</div>
                                </div> */}
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">下载状态：</div>
                                    <div className="order-detail-name-content">{orderDetail.downloadStatus ? orderDetail.downloadStatus : "暂无"}</div>
                                </div>
                            </div> :
                            orderType === 2 ? <div className="order-detail-content-wrap">
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">父订单号：</div>
                                    <div className="order-detail-name-content-2" title={orderDetail.parentOrderID}>{orderDetail.parentOrderID}</div>
                                </div>
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">提交时间：</div>
                                    <div className="order-detail-name-content-2">{transformtime(orderDetail.submitDate, 'yyyy-mm-dd hh:mm:ss')}</div>
                                </div>
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">订单类型：</div>
                                    <div className="order-detail-name-content-2">{orderDetail.orderType}</div>
                                </div>
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">订单来源：</div>
                                    <div className="order-detail-name-content-2">{orderDetail.orderSource}</div>
                                </div>
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">订单发起人：</div>
                                    <div className="order-detail-name-content-2">{orderDetail.operator}</div>
                                </div>
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">订单分解的任务数量：</div>
                                    <div className="order-detail-name-content-2" title={orderDetail.taskNumbers}>{orderDetail.taskNumbers}</div>
                                </div>
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">完成的任务数量：</div>
                                    <div className="order-detail-name-content-2">{orderDetail.finishedtaskNum}</div>
                                </div>
                                <div className="order-detail-name-wrap">
                                    <div className="order-detail-name">错误的任务数量：</div>
                                    <div className="order-detail-name-content-2">{orderDetail.errorTaskNum}</div>
                                </div>

                            </div> :
                                orderType === 21 ? <div className="order-detail-content-wrap">
                                    <div className="order-detail-name-wrap">
                                        <div className="order-detail-name">子订单号：</div>
                                        <div className="order-detail-name-content-2" title={orderDetail.proOrderId}>{orderDetail.proOrderId}</div>
                                    </div>
                                    <div className="order-detail-name-wrap">
                                        <div className="order-detail-name">子订单提交时间：</div>
                                        <div className="order-detail-name-content-2">{transformtime(orderDetail.orderSubmitTime, 'yyyy-mm-dd hh:mm:ss')}</div>
                                    </div>
                                    <div className="order-detail-name-wrap">
                                        <div className="order-detail-name">订单状态：</div>
                                        <div className="order-detail-name-content-2">{orderDetail.orderStatus}</div>
                                    </div>
                                    <div className="order-detail-name-wrap">
                                        <div className="order-detail-name">卫星名称：</div>
                                        <div className="order-detail-name-content-2">{orderDetail.satellite}</div>
                                    </div>
                                    <div className="order-detail-name-wrap">
                                        <div className="order-detail-name">卫星影像分辨率：</div>
                                        <div className="order-detail-name-content-2">{orderDetail.resolution}</div>
                                    </div>
                                    <div className="order-detail-name-wrap">
                                        <div className="order-detail-name">卫星传感器类型：</div>
                                        <div className="order-detail-name-content-2">{orderDetail.sensors}</div>
                                    </div>
                                    <div className="order-detail-name-wrap">
                                        <div className="order-detail-name">订单驱动模式：</div>
                                        <div className="order-detail-name-content-2">{orderDetail.orderDriveType}</div>
                                    </div>
                                    <div className="order-detail-name-wrap">
                                        <div className="order-detail-name">卫星数据储存位置：</div>
                                        <div className="order-detail-name-content-2">{orderDetail.dataURL}</div>
                                    </div>

                                </div> :
                                    orderType === 3 ?
                                        <div className="order-detail-content-wrap">
                                            <div className="order-detail-name-wrap">
                                                <div className="order-detail-name">订单编号：</div>
                                                <div className="order-detail-name-content">{orderDetail.orderId}</div>
                                            </div>
                                            <div className="order-detail-name-wrap">
                                                <div className="order-detail-name">创建时间：</div>
                                                <div className="order-detail-name-content">{orderDetail.orderSubmitTime ? transformtime(orderDetail.orderSubmitTime, 'yyyy-mm-dd hh:mm:ss') : "暂无"}</div>
                                            </div>
                                            <div className="order-detail-name-wrap">
                                                <div className="order-detail-name">原数据名：</div>
                                                <div className="order-detail-name-content" title={orderDetail.rawDataName}>{orderDetail.rawDataName ? orderDetail.rawDataName : "暂无"}</div>
                                            </div>
                                            <div className="order-detail-name-wrap">
                                                <div className="order-detail-name">数据来源：</div>
                                                {/* <div className="order-detail-name-content">{orderDetail.resourceType ? orderDetail.resourceType : "暂无"}</div> */}
                                                <div className="order-detail-name-content">{"生产定制"}</div>
                                            </div>
                                            <div className="order-detail-name-wrap">
                                                <div className="order-detail-name">处理状态：</div>
                                                <div className="order-detail-name-content">{orderDetail.orderStatusNow ? orderDetail.orderStatusNow : "暂无"}</div>
                                            </div>
                                        </div> :
                                        orderType === 5 ?
                                            <div className="order-detail-content-wrap">
                                                <div className="order-detail-name-wrap">
                                                    <div className="order-detail-name">订单编号：</div>
                                                    <div className="order-detail-name-content">{orderDetail.simulationrequirementid ? orderDetail.simulationrequirementid : "暂无"}</div>
                                                </div>
                                                <div className="order-detail-name-wrap">
                                                    <div className="order-detail-name">订单状态：</div>
                                                    {/* <div className="order-detail-name-content">{orderDetail.resourceType ? orderDetail.resourceType : "暂无"}</div> */}
                                                    <div className="order-detail-name-content">{orderDetail.completecondition ? orderDetail.completecondition : "暂无"}</div>
                                                </div>
                                                <div className="order-detail-name-wrap">
                                                    <div className="order-detail-name">订单来源：</div>
                                                    <div className="order-detail-name-content">{orderDetail.ordersource ? orderDetail.ordersource : "暂无"}</div>
                                                </div>
                                                <div className="order-detail-name-wrap">
                                                    <div className="order-detail-name">创建时间：</div>
                                                    <div className="order-detail-name-content">{orderDetail.starttime ? transformtime(orderDetail.starttime, 'yyyy-mm-dd hh:mm:ss') : "暂无"}</div>
                                                </div>
                                                <div className="order-detail-name-wrap">
                                                    <div className="order-detail-name">结束时间：</div>
                                                    <div className="order-detail-name-content">{orderDetail.storagetime ? transformtime(orderDetail.storagetime, 'yyyy-mm-dd hh:mm:ss') : "暂无"}</div>
                                                </div>
                                                <div className="order-detail-name-wrap">
                                                    <Button
                                                        className={orderDetail.url === null || orderDetail.completecondition !== "任务完成" ? "noDownload-address-button" : "download-address-button"}
                                                        disabled={orderDetail.url === null || orderDetail.completecondition !== "任务完成" ? true : false}
                                                        onClick={() => this.downLoadFlie(orderDetail.url)}
                                                        type="primary"
                                                    >下载</Button>
                                                </div>
                                            </div> :
                                            orderType === 6 ?
                                                <div className="order-detail-content-wrap">
                                                    <div className="order-detail-name-wrap">
                                                        <div className="order-detail-name">订单编号：</div>
                                                        <div className="order-detail-name-content">{orderDetail.orderCode ? orderDetail.orderCode : "暂无"}</div>
                                                    </div>
                                                    <div className="order-detail-name-wrap">
                                                        <div className="order-detail-name">创建时间：</div>
                                                        <div className="order-detail-name-content">{orderDetail.createDate ? transformtime(orderDetail.createDate, 'yyyy-mm-dd hh:mm:ss') : "暂无"}</div>
                                                    </div>
                                                    <div className="order-detail-name-wrap">
                                                        <div className="order-detail-name">订单来源：</div>
                                                        <div className="order-detail-name-content" title={orderDetail.orderResourceDesc}>{orderDetail.orderResourceDesc ? orderDetail.orderResourceDesc : "暂无"}</div>
                                                    </div>
                                                    <div className="order-detail-name-wrap">
                                                        <div className="order-detail-name">订单状态：</div>
                                                        {/* <div className="order-detail-name-content">{orderDetail.resourceType ? orderDetail.resourceType : "暂无"}</div> */}
                                                        <div className="order-detail-name-content">{orderDetail.orderStatus ? orderDetail.orderStatus : "暂无"}</div>
                                                    </div>
                                                    <div className="order-detail-name-wrap">
                                                        <div className="order-detail-name">产品名称：</div>
                                                        <div className="order-detail-name-content">{orderDetail.productName ? orderDetail.productName : "暂无"}</div>
                                                    </div>
                                                    <div className="order-detail-name-wrap">
                                                        <div className="order-detail-name">卫星名称：</div>
                                                        <div className="order-detail-name-content">{orderDetail.satelliteName ? orderDetail.satelliteName : "暂无"}</div>
                                                    </div>
                                                    <div className="order-detail-name-wrap">
                                                        <div className="order-detail-name">载荷名称：</div>
                                                        <div className="order-detail-name-content">{orderDetail.satelliteLoadName ? orderDetail.satelliteLoadName : "暂无"}</div>
                                                    </div>
                                                    <div className="order-detail-name-wrap">
                                                        <Button
                                                            className={productInspectionOrderDownload === null ? "noDownload-address-button2" : "download-address-button2"}
                                                            disabled={productInspectionOrderDownload === null ? true : false}
                                                            onClick={() => this.getPreviewPath(orderDetail)}
                                                            type="primary"
                                                        >预览</Button>
                                                    </div>
                                                    {/* <div className="order-detail-name-wrap">
                                                <Button
                                                    className={productInspectionOrderDownload === null ? "noDownload-address-button2" : "download-address-button2"}
                                                    disabled={productInspectionOrderDownload === null ? true : false}
                                                    onClick={() => this.getproductInspectionOrderDownload()}
                                                    type="primary"
                                                >下载检验报告</Button>
                                            </div> */}
                                                </div> :
                                                orderType === 7 ?
                                                    <div className="order-detail-content-wrap">
                                                        <div className="order-detail-name-wrap">
                                                            <div className="order-detail-name">订单编号：</div>
                                                            <div className="order-detail-name-content">{orderDetail.ordercode ? orderDetail.ordercode : "暂无"}</div>
                                                        </div>
                                                        <div className="order-detail-name-wrap">
                                                            <div className="order-detail-name">算法名称：</div>
                                                            <div className="order-detail-name-content">{orderDetail.algorithmname ? orderDetail.algorithmname : "暂无"}</div>
                                                        </div>
                                                        <div className="order-detail-name-wrap">
                                                            <div className="order-detail-name">算法类型：</div>
                                                            <div className="order-detail-name-content" title={orderDetail.algorithmclass}>{orderDetail.algorithmclass ? orderDetail.algorithmclass : "暂无"}</div>
                                                        </div>
                                                        <div className="order-detail-name-wrap">
                                                            <div className="order-detail-name">订单状态：</div>
                                                            {/* <div className="order-detail-name-content">{orderDetail.resourceType ? orderDetail.resourceType : "暂无"}</div> */}
                                                            <div className="order-detail-name-content">{orderDetail.orderstatus ? orderDetail.orderstatus : "暂无"}</div>
                                                        </div>
                                                        <div className="order-detail-name-wrap">
                                                            <div className="order-detail-name">创建时间：</div>
                                                            <div className="order-detail-name-content">{orderDetail.ordercreationtime ? transformtime(orderDetail.ordercreationtime, 'yyyy-mm-dd hh:mm:ss') : "暂无"}</div>
                                                        </div>
                                                        <div className="order-detail-name-wrap">
                                                            <div className="order-detail-name">结束时间：</div>
                                                            <div className="order-detail-name-content">{orderDetail.orderendtime ? transformtime(orderDetail.orderendtime, 'yyyy-mm-dd hh:mm:ss') : "暂无"}</div>
                                                        </div>
                                                        {/* <div className="order-detail-name-wrap">
                                                    <Button
                                                        className={orderDetail.iscluster === null || orderDetail.orderstatus !== "测评完成" ? "noDownload-address-button" : "download-address-button"}
                                                        disabled={orderDetail.iscluster === null || orderDetail.orderstatus !== "测评完成" ? true : false}
                                                        onClick={() => this.downLoadFlie(orderDetail.iscluster)}
                                                        type="primary"
                                                    >下载检验报告</Button>
                                                </div> */}
                                                        <div className="order-detail-name-wrap">
                                                            <Button
                                                                className={orderDetail.iscluster === null || orderDetail.orderstatus !== "测评完成" ? "noDownload-address-button" : "download-address-button"}
                                                                disabled={orderDetail.iscluster === null || orderDetail.orderstatus !== "测评完成" ? true : false}
                                                                onClick={() => this.getPreviewPath(orderDetail)}
                                                                type="primary"
                                                            >预览</Button>
                                                        </div>
                                                    </div> :
                                                    <div className="order-detail-content-wrap">
                                                        <div className="order-detail-name-wrap">
                                                            <div className="order-detail-name">订单编号：</div>
                                                            <div className="order-detail-name-content">{orderDetail.orderId}</div>
                                                        </div>
                                                        {orderType !== 1 && <div className="order-detail-name-wrap">
                                                            <div className="order-detail-name">创建时间：</div>
                                                            <div className="order-detail-name-content">{transformtime(orderDetail.orderCreationTime, 'yyyy-mm-dd hh:mm:ss')}</div>
                                                        </div>}
                                                        <div className="order-detail-name-wrap">
                                                            <div className="order-detail-name">文件名称：</div>
                                                            <div className="order-detail-name-content">{orderDetail.fileName ? orderDetail.fileName : "暂无"}</div>
                                                        </div>
                                                        <div className="order-detail-name-wrap">
                                                            <div className="order-detail-name">文件大小：</div>
                                                            <div className="order-detail-name-content">{orderDetail.fileSize ? this.returnFileSizeText(orderDetail.fileSize) : "暂无"}</div>
                                                        </div>
                                                        <div className="order-detail-name-wrap">
                                                            <div className="order-detail-name">数据来源：</div>
                                                            <div className="order-detail-name-content">{orderDetail.resourceType ? orderDetail.resourceType : "暂无"}</div>
                                                        </div>
                                                        {/* <div className="order-detail-name-wrap">
                                            <div className="order-detail-name">花费积分：</div>
                                            <div className="order-detail-name-content">{orderDetail.score ? orderDetail.score : "暂无"}</div>
                                        </div> */}
                                                        <div className="order-detail-name-wrap">
                                                            <div className="order-detail-name">上传状态：</div>
                                                            <div className="order-detail-name-content" title={orderDetail.statusDescribe}>{orderDetail.statusDescribe ? orderDetail.statusDescribe : "暂无"}</div>
                                                        </div>
                                                    </div>
                    }
                </div>
                <Modal className="Filedownload_Modal" visible={preLookModalFlag} footer={null} title={"预览"} destroyOnClose={true}
                    onCancel={() => this.setState({ preLookModalFlag: false })}>
                    {nowClickFile ?
                        <Fragment>
                            <div className='Filedownload_Modal_Title'>
                                <div className='Filedownload_Modal_TitleText'>{nowClickFile.fileName}</div>
                            </div>
                            {/* <div className='Filedownload_Modal_Content'>
                                <iframe id="Filedownload_Modal_Iframe" className='Filedownload_Modal_Iframe'
                                    src={this.returnUrl(nowClickFile.url)} onLoad={this.iframeOnload}
                                    
                                />  
                            </div> */}
                            {
                                filePreviewPath === '' ?
                                    <div className="Filedownload_Modal_Empty">暂无内容</div> :
                                    filePreviewPath.split('.')[4] === 'pdf' ?
                                        <>
                                            <div className="pdfViewer-content">
                                                <PDFViewer
                                                    // fileType={filePreviewPath.split('.')[4]}
                                                    onDocumentComplete={this.onDocumentComplete}
                                                    page={pdfPage}
                                                    file={filePreviewPath}
                                                ></PDFViewer>
                                            </div>
                                            <div className="pdfViewer-footer">
                                                {
                                                    pdfPage === 1 ? null :
                                                        <Button type="primary" className="left-change-page" onClick={() => this.handlePrivious()}>上一页</Button>
                                                }
                                                <div className="pdfViewer-footer-changPage">
                                                    <span>第{pdfPage}页</span>/<span>共{pdfTotalPages}页</span>
                                                </div>
                                                {
                                                    pdfPage === pdfTotalPages ? null :
                                                        <Button type="primary" className="right-change-page" onClick={() => this.handleNext()}>下一页</Button>
                                                }
                                            </div>
                                        </> :
                                        <div className="fileViewer-content">
                                            <FileViewer
                                                fileType={filePreviewPath.split('.')[4]}
                                                filePath={filePreviewPath}
                                            // filePath='http://10.0.121.14:8084/tiles/综合数据库/文档数据/KJ 10001-2022新闻信息.docx'
                                            >
                                            </FileViewer>
                                        </div>
                            }

                        </Fragment>
                        : <div className="Filedownload_Modal_Empty">暂无内容</div>}
                </Modal>
            </CustomModal>
        )
    }

    //获得预览
    getPreviewPath = async (data) => {
        const { productInspectionOrderDownload } = this.state;
        this.setState({ nowClickFile: data });
        let url = productInspectionOrderDownload || data.iscluster;
        console.log("getPreviewPath", url, data, productInspectionOrderDownload);
        this.setState({
            filePreviewPath: url
        }, () => {
            this.setState({ preLookModalFlag: true, })
        })
        // const { data: res } = await axios.get(`/dataBaseDocQueryUrl/api/getDocumentPath?dataNames=${dataName}&dataType=document`, {
        //     headers: {
        //         Authorization: this.props.zd_user.token
        //     }
        // })
        // if (res.code !== '0') {
        //     message.error('文档预览失败！')
        // } else {
        //     this.setState({
        //         filePreviewPath: Object.values(res.data)[0]
        //     }, () => {
        //         this.setState({ preLookModalFlag: true, })
        //     })
        // }
    }
    onDocumentComplete = (pages) => {
        this.setState({
            pdfPage: 1,
            pdfTotalPages: pages
        })
    }
    handlePrivious = () => {
        this.setState({
            pdfPage: this.state.pdfPage - 1

        })
    }
    handleNext = () => {
        this.setState({
            pdfPage: this.state.pdfPage + 1

        })
    }

    returnOrderStatus = (status) => {
        if (status === "assigned") {
            return "处理中";
        }
        else if (status === "created") {
            return "待处理";
        }
        else if (status === "finished") {
            return "已完成";
        }
        else {
            return "未知状态";
        }
    }
    returnFileSizeText = (size) => {
        if ((size / 1000) < 1000) {
            return (size / 1000).toFixed(2) + " KB";
        }
        else if ((size / 1024 / 1000) < 1000) {
            return (size / 1024 / 1000).toFixed(2) + " MB";
        }
        else if ((size / 1024 / 1024 / 1000) < 1000) {
            return (size / 1024 / 1024 / 1000).toFixed(2) + " GB";
        }
        else {
            return (size / 1024 / 1024 / 1024 / 1000).toFixed(2) + " TB";
        }
    }
}

const mapState = state => ({
    user: state.userReducer.get('user').toJS(),
    zd_user: state.userReducer.get('zd_user').toJS(),
})

export default connect(mapState)(OrderDetail)